// This file is auto-generated. Edit data.graphql to change it.
import { DataProvider , useSetFlowToBasedOnData } from 'Simple/Data'
import { useQuery } from 'Data/Api'
import useDataTransform from './useDataTransform'
import useDataConfiguration from './useDataConfiguration'
import query from './data.graphql.js'
import React from 'react'
import View from './view'

/** @type {import('Simple/types.js').Data} */
export default function PaymentPlansData(props) {
  let configuration = useDataConfiguration(props)
  let [{ data: rdata, fetching, error }, reExecuteQuery] = useQuery({ query, ...configuration })
  let data = useDataTransform(props, rdata?.treatments_default_payment_plans)

      useSetFlowToBasedOnData({
        data,
        fetching,
        error,
        pause: configuration.pause,
        viewPath: props.viewPath,
      })
      

  return (
    <DataProvider
      context="payment_plans"
      value={data}
      viewPath={props.viewPath}
    >
      <View {...props} />
    </DataProvider>
  )
}